
<div class="col-xs-12 p-0">
  <div class="mr-2 mb-2 inline posR bdr" *ngFor="let file of imageFiles;let i = index;"><img [src]="file"/><i class="fas fa-trash" (click)="removeFile(i)"></i></div>
</div>
<input class="form-control" [required]="!imageFiles?.length && required" name="{{name}}" [(ngModel)]="parseValue" type="file" #file (change)="onFileChange(file.files)" [accept]="accept" id="{{name}}"/>
<label class="mt-0" for="{{name}}"><em class="fa fa-download text-white pr-2"></em><span>Upload File</span></label>
